<template>
  <van-dialog
    class="special-dialog"
    v-model:show="visible"
    :title="mb_t('特殊登陆验证')"
    show-cancel-button
    :cancel-button-text="mb_t('取消')"
    :confirm-button-text="mb_t('确认')"
    :before-close="beforeClose"
    @confirm="onConfirm"
    @cancel="visible = false"
    teleport="body"
  >
    <div class="dialog-content">
      <van-field
        class="from-input"
        label-align="top"
        type="text"
        v-model="val"
        :label="label"
        :placeholder="placeholder"
        :rules="[{ required: true, message: placeholder }]"
      />
    </div>
  </van-dialog>
</template>

<script setup lang="ts">
import { computed, defineEmits, defineModel, onMounted, ref } from 'vue';
import { useTenantStore } from '@star/stores';
import { storeToRefs } from 'pinia';
import { mb_t } from '@star/languages';
import { showNotify } from 'vant';

const tenantState = useTenantStore();
const { sysLoginOptions } = storeToRefs(tenantState);

type Props = {
  code: string;
};

const props = withDefaults(defineProps<Props>(), {
  code: '0',
});

const emit = defineEmits(['confirm']);
const visible = defineModel<boolean>();
const val = ref<string>();

const label = computed(() => {
  if (props.code === '1') {
    return mb_t('支付密码');
  } else if (props.code === '2') {
    return mb_t('真实姓名');
  } else if (props.code === '3') {
    return mb_t('默认银行卡后4位');
  }
});

const placeholder = computed(() => {
  if (props.code === '1') {
    return mb_t('请输入支付密码');
  } else if (props.code === '2') {
    return mb_t('请输入真实姓名');
  } else if (props.code === '3') {
    return mb_t('请输入默认银行卡后4位');
  }
});

const beforeClose = () => {
  if (!val.value) {
    showNotify({ type: 'warning', message: placeholder.value });
  }
  return !!val.value;
};

const onConfirm = async () => {
  emit('confirm', val.value);
};

onMounted(() => {});
</script>

<style scoped lang="less">
.dialog-content {
  padding: 30px 0;
}
</style>
